module.exports = __webpack_public_path__ + "img/symbol_6.baff83d9.png";